import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { ContentsquareReplayButton } from './ContentsquareReplayButton';
import { ContentsquareReplayIcon } from './ContentsquareReplayIcon';

export interface ContentsquareReplayLinkProps {
  url: string;
  type: 'icon' | 'button';
  trackUiPosition: string;
}

export const ContentsquareReplayLink = ({
  url,
  type,
  trackUiPosition,
}: ContentsquareReplayLinkProps): JSX.Element => {
  const { click: trackClick } = useTrack();

  const onClickTrack = () => {
    trackClick('play_cs_replay', trackUiPosition, {});
  };

  if (type === 'icon') {
    return <ContentsquareReplayIcon url={url} onClick={onClickTrack} />;
  }

  return <ContentsquareReplayButton url={url} onClick={onClickTrack} />;
};
